import { render, staticRenderFns } from "./CashJournalPage.vue?vue&type=template&id=4d8cfab6&scoped=true&"
import script from "./CashJournalPage.vue?vue&type=script&lang=js&"
export * from "./CashJournalPage.vue?vue&type=script&lang=js&"
import style0 from "./CashJournalPage.vue?vue&type=style&index=0&id=4d8cfab6&prod&scoped=true&lang=css&"
import style1 from "./CashJournalPage.vue?vue&type=style&index=1&id=4d8cfab6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8cfab6",
  null
  
)

export default component.exports